import { GoToNextStateAct } from "onearm";
import { AsyncActionsScenario } from "onearm";
import { SubGameState } from "./SubGameState";

export class WinPresentation extends SubGameState {
    enter({ result, quickStop = false }) {
        this.quickStop = quickStop;
        this.resultScenarion = this.makeResultPresentation(result);
        this.resultScenarion.start();
        this.addSignalHandler(this.hud.onPressStop, this.pressStopHandler);
        this.addSignalHandler(this.keyboard.onSpacePress, this.skipSpin);

        if (this.autoplay.isActive() && this.autoplay.isTurboSpin) {
            this.skipAllResults();
        }
    }

    stopAutoplay() {
        if (this.autoplay.isActive()) {
            this.autoplay.stop();
        }
        this.hud.showAutoplayButton();
    }

    pressStopHandler() {
        this.skipSpin();
        this.stopAutoplay();
    }

    skipAllResults() {
        if (this.resultScenarion) {
            this.resultScenarion.skipAllIfPossible();
        }

        if (this.resultScenarion ? this.resultScenarion.completed : true) {
            this.resultScenarion = null;
        }
    }

    exit() {
        super.exit();

        if (this.autoplay.isActive()) {
            const win = this.gameLogic.totalWin;
            const loss = win === 0 ? this.gameLogic.bet : 0;
            this.autoplay.next({ win, loss });
        }

        if (!this.autoplay.isActive()) {
            const infoTexts = ["PLACE YOUR BETS! ","SPIN TO WIN!","HOLD SPACE FOR TURBO SPIN"];
            this.hud.setInfoText(infoTexts[Math.floor(Math.random() * infoTexts.length)]);
        } else {
            this.hud.showInfo(`AUTO SPINS LEFT: ${this.autoplay.getGamesLeft()}`);
        }
    }

    skipSpin() {
    }

    makeResultPresentation(result) {
        const actions = this.gameState.makeSpinResultPresentation(result, {}, { quickStop: this.quickStop});

        actions.push(
            new GoToNextStateAct({ gameState: this.gameState, gameLogic: this.gameLogic }),
        );

        return new AsyncActionsScenario({ actions });
    }
}
